<template>
  <div class="list-container" :style="'background:'+theme.themeSubColor">
    <div class="nav">
      <h2>{{theme.name ? theme.name : '全国青少年编程能力测评系统'}}</h2>
      <div class="user-wrap">
        <p class="detect" @click="goDetect" v-if="theme.deviceCheckOpen"><i class="icon-device"></i>设备检测</p>
      </div>
      <div class="bg" :style="'background:'+theme.themeColor"></div>
    </div>
    <div class="list-wrap">
      <div class="formTitle">
        <span @click="gobackList" class="backText">
          <i class="el-icon-arrow-left backIcon"></i>
          返回
        </span>
        <p class="titleText">登录个人信息</p>
      </div>
      <div class="formContainer">
        <el-form :model="ruleForm" :rules="formRules" ref="ruleForm" label-width="130px" class="demo-ruleForm">
          <el-form-item :label="it.showName"  :prop="it.bizName" v-for="(it) in fieldList" :key="it.id">
            <el-input :maxlength="hasMaxlength(it.bizName)" v-if="it.inputType === 'TXT'" class="touristsInput" :placeholder="`请输入${it.showName}`" v-model="ruleForm[it.bizName]"></el-input>
            <el-radio-group v-if="it.inputType === 'DROP_DOWN_GENDER'" v-model="ruleForm.sex" size="medium">
              <el-radio-button :key="i" v-for="(its, i) in sexType" :label="its.value">{{ its.label }}</el-radio-button>
            </el-radio-group>
            <el-select v-if="it.inputType === 'DROP_DOWN_IDTYPE'" class="touristsInput" v-model="ruleForm.idType" placeholder="请选择证件类型">
              <el-option :key="i" v-for="(its, i) in userIdType" :label="its.label" :value="its.value"></el-option>
            </el-select>
            <area-cascader
              v-if="it.inputType === 'DROP_DOWN_REGION'"
              v-model="ruleForm.districtId"
              placeholder="请选择地区"
              @change="regionChange"
              style="width: 100%"
            />
            <el-select v-if="it.inputType === 'DROP_DOWN_NORMAL'" class="touristsInput" v-model="ruleForm[it.bizName]" :placeholder="`请选择${it.showName}`" filterable>
              <el-option :key="i" v-for="(item, i) in it.candidateValues" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button class="touristsBtn" type="primary" @click="submitForm('ruleForm')">确认</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { post } from '@/utils/ajax'
import { setTouristsToken, setTouristsUserId } from '@/utils'
import { mapState } from 'vuex'
import { sexType, userIdType, gradeType } from './constant'
import AreaCascader from './AreaCascader.vue'
import { Form, FormItem, Button, Select, Option, Input, RadioButton, RadioGroup } from 'element-ui'
import { loginEvent } from '@/utils/sensor'

export default {
  components: {
    ElForm: Form,
    ElFormItem: FormItem,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
    ElButton: Button,
    ElRadioGroup: RadioGroup,
    AreaCascader,
    ElRadioButton: RadioButton
  },
  computed: {
    ...mapState(['user', 'theme', 'site_msg']),
    fieldList() {
      const ignoreList = ['countryId', 'cityId', 'provinceId']
      const list = this.site_msg.submitterFieldsDetailOutbound.filter((item) => !ignoreList.includes(item.bizName) && item.checked)
      // 处理年级，为空则显示默认列表
      const grade = list.find(el => el.bizName === 'grade')
      if (grade) {
        grade.candidateValues = grade.candidateValues.filter(el => el !== '')
        if (grade.candidateValues.length === 0) {
          grade.candidateValues = gradeType
        }
      }
      return list
    },
    hasMaxlength() {
      return (key) => {
        const _keys = ['name', 'class', 'grade']
        const _phones = ['mobile', 'teacherMobile']
        if (_keys.includes(key)) {
          return 20
        } else if (_phones.includes(key)) {
          return 11
        } else {
          return 40
        }
      }
    },
    cityOptions() {
      return this.$store.state.areaList
    },
    fingerPrint() {
      return this.$store.state.browserFinger
    },
    formRules() {
      const _rules = {}
      this.fieldList.map((item) => {
        if (item.optional) {
          const _msg = item.inputType === 'TXT' ? '请输入' : '请选择'
          _rules[item.bizName] = [
            { required: true, message: `${_msg}${item.showName}`, trigger: 'blur' }
          ]
          if (this.initRules[item.bizName]) {
            _rules[item.bizName].push(...this.initRules[item.bizName])
          }
        }
      })
      return _rules
    }
  },
  data() {
    const checkPhone = (rule, value, callback) => {
      if (!Number.isInteger(Number(value))) {
        callback(new Error('手机号需要为数字'))
      } else {
        if (value.length !== 11) {
          callback(new Error('手机号长度需11位数字'))
        } else {
          callback()
        }
      }
    }
    const checkIdNumber = (rule, value, callback) => {
      if (this.ruleForm.idType === 1) {
        if (!Number.isInteger(Number(value))) {
          callback(new Error('身份证需要为数字'))
        } else {
          if (value.length !== 18) {
            callback(new Error('身份证长度需18位数字'))
          } else {
            callback()
          }
        }
      } else {
        callback()
      }
    }
    return {
      userIdType,
      sexType,
      initRules: {
        teacherMobile: [{ validator: checkPhone, trigger: 'blur' }],
        mobile: [{ validator: checkPhone, trigger: 'blur' }],
        idNumber: [{ validator: checkIdNumber, trigger: 'blur' }]
      },
      selectType: ['DROP_DOWN_NORMAL', 'DROP_DOWN_IDTYPE', 'DROP_DOWN_GENDER', 'DROP_DOWN_REGION'],
      ruleForm: {
        districtId: []
      }
    }
  },
  async mounted () {
  },
  methods: {
    regionChange(val) {
      // 设置当前选中的省市区
      const pOobj = this.cityOptions.find((row) => row.id === val[0])
      const cObj = pOobj.children.find((row) => row.id === val[1])
      const dObj = cObj.children && cObj.children.find((row) => row.id === val[2])
      const cityName = `${pOobj.name}${cObj.name}${dObj ? dObj.name : ''}`
      console.log('cityName', cityName)
      window.localStorage.setItem('TOURISTSCITY', cityName)
    },
    gobackList() {
      this.$router.go(-1)
    },
    goDetect() {
      const routeUrl = this.$router.resolve({
        name: 'detect'
      })
      window.open(routeUrl.href, '_blank')
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const submitterInfo = []
          const obj = {
            ...this.ruleForm,
            cityId: this.ruleForm.districtId ? this.ruleForm.districtId[1] : undefined,
            districtId: this.ruleForm.districtId ? this.ruleForm.districtId[2] : undefined,
            provinceId: this.ruleForm.districtId ? this.ruleForm.districtId[0] : undefined,
            countryId: 156
          }
          this.site_msg.submitterFieldsDetailOutbound.map((item) => {
            // 需要兼容值为0的情况
            if (obj[item.bizName] !== null && obj[item.bizName] !== undefined && obj[item.bizName] !== '') {
              submitterInfo.push({
                bizName: item.bizName,
                id: item.id,
                value: obj[item.bizName]
              })
            }
          })
          const params = {
            deviceInfo: { fingerPrint: this.fingerPrint },
            examId: Number(window.localStorage.examId),
            siteId: this.theme.id,
            submitterInfo
          }
          this.finalSubmit(params)
        } else {
          console.error('error submit!!')
          return false
        }
      })
    },
    async finalSubmit(params) {
      await post(`/home/submitter`, params).then((data) => {
        if (data) {
          setTouristsToken(data.anonymousToken)
          setTouristsUserId(data.userId)
          loginEvent({ id: data.userId })
          this.$store.dispatch('getTouristsId', data.userId).then((data) => {
            this.$router.push({ name: 'pretest' })
          })
        } else {
          throw new Error('未返回登录态')
        }
      }).catch((error) => {
        console.log('error', error)
        this.$router.push({ name: 'list' })
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  destroyed () {
  }
}
</script>

<style lang="scss" scoped>
.list-container {
  display: flex;
  flex-direction: column;
  // height: 100%;
  min-height: 900px;
  min-width: 1400px;
}
.nav {
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  height: 257px;
  min-height: 257px;
  color: #fff;
  .bg {
    position: absolute;
    width: 18000px;
    height: 18000px;
    border-radius: 50%;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
  h2 {
    z-index: 1;
    font-size: 30px;
    font-weight: 400;
    color: #fff;
    margin: 23px 0 0 60px;
    height: 50px;
  }
  .user-wrap {
    position: relative;
    z-index: 1;
    margin: 23px 60px 0 0;
    line-height: 30px;
    height: 30px;
    display: flex;
    font-size: 14px;
    i {
      display: inline-block;
      width: 14px;
      height: 14px;
      margin-right: 8px;
    }
    .detect, .logout {
      display: flex;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
    }
    .logout {
      margin-left: 30px;
    }
    &:hover {
      .user-pop {
        display: block;
      }
    }
  }
  .user {
    cursor: pointer;
    display: block;
    font-size: 14px;
    font-weight: 300;
    height: 30px;
    i {
      display: inline-block;
      vertical-align: middle;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 10px;
      background: url('https://static-user-center.codemao.cn/user_0005.png') no-repeat center / cover;
    }
  }
  .user-pop {
    display: none;
    position: absolute;
    padding-top: 15px;
    left: 50%;
    transform: translateX(-50%);
  }
  .user-func {
    background: #fff;
    padding: 10px 0;
    border-radius: 3px;
    box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.15);
    &::before {
      content: '';
      position: absolute;
      border: 8px solid #fff;
      border-left-color: transparent;
      border-right-color: transparent;
      border-top-color: transparent;
      top: -1px;
      right: 49px;
    }
    li {
      cursor: pointer;
      width: 160px;
      height: 46px;
      line-height: 46px;
      text-align: center;
      color: #333;
      font-weight: 300;
      font-size: 14px;
    }
  }
  .icon-logout {
    background: url("~@/assets/images/icon-logout.png") center / cover no-repeat;
    margin-left: 30px;
  }
  .icon-device {
    background: url("~@/assets/images/icon-device.png") center / cover no-repeat;
  }
}
.list-wrap {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 1200px;
  // height: 820px;
  background: #fff;
  border-radius: 8px 8px 0 0;
  margin: -160px auto 50px;
  box-shadow:0px 0px 20px 0px rgba(0,0,0,0.1);
}
.formTitle {
  display: flex;
  padding: 28px 35px;
  justify-content: center;
  align-items: center;
  .backText {
    cursor: pointer;
    width: 60px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
    line-height: 20px;
  }
  .titleText {
    margin-right: 60px;
    flex: 1;
    text-align: center;
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
  }
}
.formContainer {
  margin: 10px auto;
  .touristsInput {
    width: 340px;
    height:42px;
  }
  .touristsBtn {
    width: 340px;
    height:42px;
  }
}
</style>
